/**
 * JsonFallback renderer (Req 2.5): pretty-printed JSON for unknown/missing
 * kinds, so the UI never crashes on unexpected frames.
 */
export function JsonFallback({ title, data, accent }: { title?: string; data: unknown; accent: string }) {
  let json: string;
  try {
    json = JSON.stringify(data, null, 2);
  } catch {
    json = String(data);
  }

  return (
    <div className="rounded-lg bg-slate-900 p-5">
      {title ? (
        <h2 className="text-xl font-semibold mb-4" style={{ color: accent }}>
          {title}
        </h2>
      ) : null}
      <pre className="overflow-auto text-sm text-slate-200">{json ?? 'null'}</pre>
    </div>
  );
}
